import { h } from './index.js';
import { t as toValue, a as toLabel } from './p-CPuegN2k.js';
import { i as isLavOption } from './p-CdnDatdH.js';

function optionHasChildren(option) {
    return Boolean(option && typeof option === 'object' && 'children' in option && option.children);
}
function getFlatLavOptions(options) {
    return options
        .flatMap((v) => {
        return optionHasChildren(v) ? [v, ...v.children] : [v];
    })
        .filter(isLavOption);
}
function getCheckedAllStatus(options, value) {
    if (typeof options === 'undefined' || typeof value === 'undefined') {
        return 'none';
    }
    const flatLavOptions = getFlatLavOptions(options);
    if (flatLavOptions.length === 0 || value.length === 0) {
        return 'none';
    }
    if (flatLavOptions.every((v) => value?.includes(toValue(v)))) {
        return 'every';
    }
    return 'some';
}

// biome-ignore lint/correctness/noUnusedImports: needed for Stencil
function HiddenHTMLSelect({ disabled, required, name, options, value, ref, multiple, }) {
    return (h("select", { ref: ref, multiple: multiple, hidden: true, disabled: disabled, required: required, name: name }, getFlatLavOptions(options ?? []).map((option) => {
        const optionValue = toValue(option);
        const optionLabel = toLabel(option);
        const isOptionChecked = (value || []).includes(`${optionValue}`);
        const isOptionDisabled = typeof option === 'object' && option.disabled;
        return (h("option", { key: optionLabel, selected: isOptionChecked, disabled: disabled || isOptionDisabled, value: optionValue }, optionLabel));
    })));
}

export { HiddenHTMLSelect as H, getCheckedAllStatus as a, getFlatLavOptions as g, optionHasChildren as o };
